import React from 'react';

const Modal = ({ type, onClose }) => {
  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('modal')) {
      onClose();
    }
  };

  const renderContent = () => {
    if (type === 'terms') {
      return (
        <div className="legal-content">
          <h2>Terms of Service</h2>
          <p><strong>Last Updated: February 2026</strong></p>
          
          <p>Welcome to Greenbucks Engineering Solution. These Terms of Service ("Terms") govern your use of our services and website. By engaging our services or accessing our website, you agree to these Terms.</p>

          <h3>1. Services Provided</h3>
          <p>Greenbucks Engineering Solution ("Company," "we," "our," or "us") provides:</p>
          <ul>
            <li><strong>Technology Development Services:</strong> Including but not limited to web development, mobile application development, cloud services, AI/ML solutions, and digital consulting.</li>
            <li><strong>IT Staffing Services:</strong> Provision of skilled technology professionals to clients on contractual, project-based, or full-time placement basis.</li>
          </ul>

          <h3>2. Client Responsibilities</h3>
          <ul>
            <li><strong>Information Provision:</strong> Clients must provide accurate, complete, and timely information necessary for project execution.</li>
            <li><strong>Cooperation:</strong> Clients agree to cooperate with our team, provide timely feedback, and make necessary decisions to facilitate project progress.</li>
            <li><strong>Payment:</strong> Clients agree to pay all fees as per the agreed payment terms outlined in project contracts or service agreements.</li>
          </ul>

          <h3>3. Intellectual Property</h3>
          <ul>
            <li><strong>Deliverables:</strong> Upon full payment, clients receive ownership of custom-developed deliverables specific to their project, excluding pre-existing tools, frameworks, or methodologies.</li>
            <li><strong>Company IP:</strong> All pre-existing intellectual property, frameworks, tools, and methodologies developed by Greenbucks Engineering Solution remain our exclusive property.</li>
            <li><strong>Third-Party Components:</strong> Projects may include third-party libraries, frameworks, or services subject to their respective licenses.</li>
          </ul>

          <h3>4. Payment Terms</h3>
          <p>Payment schedules will be outlined in individual project contracts or service agreements. Late payments may incur interest charges of 1.5% per month or the maximum allowed by law. We reserve the right to suspend services for non-payment.</p>

          <h3>5. Contact</h3>
          <p>For questions about these Terms, contact us at: legal@greenbucks.engineering</p>
        </div>
      );
    } else {
      return (
        <div className="legal-content">
          <h2>Privacy Policy</h2>
          <p><strong>Last Updated: February 2026</strong></p>
          
          <p>Greenbucks Engineering Solution ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information.</p>

          <h3>1. Information We Collect</h3>
          <ul>
            <li><strong>Contact Information:</strong> Name, email address, phone number, company name, and job title when you contact us or engage our services.</li>
            <li><strong>Project Information:</strong> Technical requirements, business objectives, and other information necessary to deliver our services.</li>
            <li><strong>Professional Information:</strong> Resume, work experience, skills, and portfolio when applying for positions.</li>
            <li><strong>Usage Data:</strong> IP address, browser type, device information, pages visited, and time spent on our website.</li>
          </ul>

          <h3>2. How We Use Your Information</h3>
          <p>We use collected information to:</p>
          <ul>
            <li>Provide and deliver our technology development and IT staffing services</li>
            <li>Communicate with clients about projects, updates, and service-related information</li>
            <li>Process payments and maintain financial records</li>
            <li>Improve our website, services, and customer experience</li>
            <li>Evaluate job applications and manage recruitment processes</li>
          </ul>

          <h3>3. Data Security</h3>
          <p>We implement industry-standard security measures to protect your information, including encryption of data in transit and at rest, regular security assessments and updates, and access controls limiting data access to authorized personnel.</p>

          <h3>4. Your Rights</h3>
          <p>You have the right to access, correct, delete your data, and opt-out of marketing communications. To exercise these rights, contact us at privacy@greenbucks.engineering</p>

          <h3>5. Contact</h3>
          <p>For questions about this Privacy Policy, contact us at: privacy@greenbucks.engineering</p>
        </div>
      );
    }
  };

  return (
    <div className="modal active" onClick={handleBackdropClick}>
      <div className="modal-content">
        <button className="close-modal" onClick={onClose}>&times;</button>
        {renderContent()}
      </div>
    </div>
  );
};

export default Modal;
